import React from 'react';

function ContactModal() {
  return (
    <div
      className="modal fade modal-contact-popup-one"
      id="contactModal"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="contactModalTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <main className="main-body modal-content clearfix">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <img src="./assets/images/icon/close.svg" alt="" />
          </button>
          <div className="left-side">
            <div className="d-flex flex-column justify-content-between h-100">
              <div className="row">
                <div className="col-xl-10 col-lg-8 m-auto">
                  <blockquote>
                    "The future belongs to those who harness the power of data."
                  </blockquote>
                  <span className="bio">—Cybernate Team</span>
                </div>
              </div>
              <img
                src="./assets/images/assets/ils_18.svg"
                alt=""
                className="illustration mt-auto"
              />
            </div>
          </div>
          <div className="right-side">
            <h2 className="form-title">Get in touch</h2>
            <form action="#" id="contact-form" data-toggle="validator">
              <div className="messages" />
              <div className="row controls">
                <div className="col-12">
                  <div className="input-group-meta form-group mb-15">
                    <label>Name</label>
                    <input
                      type="text"
                      placeholder="Your Name"
                      name="Fname"
                      required="required"
                      data-error="Name is required."
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-12">
                  <div className="input-group-meta form-group mb-15">
                    <label>Company</label>
                    <input
                      type="text"
                      placeholder="Your Company"
                      name="company"
                      required="required"
                      data-error="Company is required."
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-12">
                  <div className="input-group-meta form-group mb-35">
                    <label>Email*</label>
                    <input
                      type="email"
                      placeholder="Email Address"
                      name="email"
                      required="required"
                      data-error="Valid email is required."
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-12">
                  <div className="input-group-meta form-group mb-25">
                    <textarea
                      placeholder="Tell us about your AI needs"
                      name="message"
                      required="required"
                      data-error="Please, leave us a message."
                      defaultValue={""}
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-12">
                  <button className="theme-btn-seven w-100">
                    Request Demo
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}

export default ContactModal;